<template>
    <div>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="'bottom'" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light curved-header" style="--height-curved:180px;">
            <div class="pageTitle left">
                <img :src="require('@/assets/image/logo_header_white.png')" alt="logo" class="logo">
            </div>
            <div class="right">
                <router-link :to="{name:'care-center'}" class="headerButton">
                    <div>
                        <p style="font-size: 10px;line-height: 1.5;margin: 0;width: 60px;text-align: right;">Hubungi<br>Kami</p>
                    </div>
                    <ion-icon class="icon ml-1" name="chatbox-ellipses"></ion-icon>
                </router-link>
            </div>
            <div class="section wallet-card-section w-100" style="margin-top:100px;">
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <span class="title">Saldo Anda</span>
                            <h1 class="total" :class="{'loading-component': loading.content}"><span>Rp {{ customer.balance | rupiah }}</span></h1>
                        </div>
                        <div class="col-6 text-right">
                            <span class="title">Komisi Anda</span>
                            <h1 class="total" :class="{'loading-component': loading.content}"><span>Rp {{ customer.komisi | rupiah }}</span></h1>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <div class="item">
                            <router-link :to="{name:'deposit'}">
                                <div class="icon-wrapper bg-primary">
                                    <ion-icon name="add-circle"></ion-icon>
                                </div>
                                <strong>Deposit</strong>
                            </router-link>
                        </div>
                        <!-- <div class="item">
                            <router-link :to="{name:'transfer'}">
                                <div class="icon-wrapper bg-primary">
                                    <ion-icon name="paper-plane"></ion-icon>
                                </div>
                                <strong>Transfer</strong>
                            </router-link>
                        </div> -->
                        <div class="item">
                            <a href="Javascript:;" @click="coming">
                                <div class="icon-wrapper bg-primary">
                                    <ion-icon name="archive"></ion-icon>
                                </div>
                                <strong>Kirim Uang</strong>
                            </a>
                        </div>
                        <div class="item">
                            <router-link :to="{name:'mutasi'}">
                                <div class="icon-wrapper bg-primary">
                                    <ion-icon name="reader"></ion-icon>
                                </div>
                                <strong>Mutasi</strong>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="appCapsule" style="padding-top:55px;">
            <!-- * Banner Informasi & Promo -->
            <div class="section full mb-2" >
                <!-- <div class="section-heading padding mb-1">
                    <h2 class="title" style="font-size:15px;">Informasi & Promo</h2>
                    <router-link :to="{name:'info.index'}" class="link" style="font-size:12px;">Lihat Semua</router-link>
                </div> -->
                <div v-if="banner.length > 0">
                    <carousel :autoplay="true" :nav="false" :dots="true" :loop="true" :items="1" :stagePadding="30" :margin="15">
                        <img v-for="item in banner" :key="item.index" :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/banner/'+item.banner" class="imaged" :alt="item.title" @click="showInformation(item.information_id)">
                    </carousel>
                </div>
                <div v-else>
                    <img :src="require('@/assets/loading_banner.jpg')" class="imaged w-100">
                </div>
            </div>
            <div class="section mb-3" v-if="customer.account_verified_status != 'APPROVED'">
                <div class="alert alert-outline-primary text-center" role="alert" style="line-height:1rem">
                    <small>Verifikasi Data Diri sekarang untuk menghindari batas maksimum transaksi dan saldo kamu</small><br>
                    <router-link :to="{name:'account.data-diri'}" class="btn btn-primary btn-sm btn-block mt-1" style="text-decoration:none;"><span style="color:white;">Lihat Selengkapnya</span></router-link>
                </div>
            </div>
            <div class="section order-menu clearfix" style="margin-bottom:15px;" v-if="chunkCategoryUtama.length > 0">
                <div class="menu" v-for="chunks in chunkCategoryUtama" :key="chunks.index">
                    <div class="item" v-for="item in chunks" :key="item.id">
                        <!-- <router-link :to="{name:'order-prabayar', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix}}" v-if="item.withPrefix === 1">
                            <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                            <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                        </router-link> -->

                        <router-link :to="{name:'product-prabayar-prefix', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix}}" v-if="item.withPrefix === 1">
                            <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                            <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                        </router-link>

                        <router-link :to="{name:'product-prabayar', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix, styleProduct:item.style_product}}" v-else>
                            <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                            <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                        </router-link>
                    </div>
                    <div class="item" v-if="chunks.length <= 3">
                        <router-link :to="{name:'other'}">
                        <!-- <a href="Javascript:;" @click="modalProduct('show')"> -->
                            <img :src="require('@/assets/Semua.png')" alt="image" class="imaged" style="width:60%;">
                            <strong style="margin:3px;font-size:10px;">Semua</strong>
                        <!-- </a> -->
                        </router-link>
                    </div>
                </div>
            </div>

            <ul class="listview image-listview media">
                <li>
                    <router-link :to="{name:'care-center'}" class="item">
                        <div class="imageWrapper">
                            <img :src="require('@/assets/cs.png')" alt="image" class="imaged w64">
                        </div>
                        <div class="in">
                            <div>
                                Butuh Bantuan?
                                <div class="text-muted" style="line-height:0.9rem;"><small>Tidak perlu bingung! Kami akan bantu jika ada kendala atau pertanyaan seputar Qiosfin.</small></div>
                            </div>
                        </div>
                    </router-link>
                </li>
            </ul>
            <!-- Panduan & Tutorial -->
            <!-- <div class="section full mt-3 mb-3">
                <div class="section-heading padding">
                    <h2 class="title">Panduan & Tutorial</h2>
                    <router-link class="link" :to="{name:'prabayar', params:{id:7, title:'Topup Game', withPrefix:0}}">
                        Lihat Semua
                    </router-link>
                </div>
                <carousel :autoplay="false" :nav="false" :dots="false" :loop="false" :items="3" :stagePadding="15" :margin="7">
                    <div class="item" v-for="(item, index) in gamefav" :key="index">
                        <router-link :to="{name:'order-prabayar', params:{id:7, title:'Topup Game Terpopuler', withPrefix:0, operator_data: item}}">
                            <div class="blog-card">
                                <img v-lazyload :src="require('@/assets/gamefav/loading.jpg')" :data-src="require(`@/assets/gamefav/${item.image}`)" alt="image" class="imaged w-100">
                                <div class="text">
                                    <h4 class="title" style="height:30px;">{{ item.product_name }}</h4>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </carousel>
            </div> -->
            <!-- Produk Fisik -->
            <!-- <div class="section full mb-3">
                <div class="section-heading padding">
                    <h2 class="title">Produk Fisik</h2>
                    <a href="#" class="link">Lihat Semua</a>
                </div>
                <carousel :autoplay="true" :nav="false" :dots="false" :loop="false" :items="2" :stagePadding="10" :margin="10">
                    <div class="item">
                        <a href="#">
                            <div class="blog-card">
                                <img :src="require('@/assets/product-empty.jpg')" alt="image" class="imaged w-100">
                                <div class="text">
                                    <h4 class="title">Grosir Kartu Perdana Tri 4G LTE TerMurah</h4>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="item">
                        <a href="#">
                            <div class="blog-card">
                                <img :src="require('@/assets/product-empty.jpg')" alt="image" class="imaged w-100">
                                <div class="text">
                                    <h4 class="title">Kartu Combo Sakti Telkomsel 15GB Murah</h4>
                                </div>
                            </div>
                        </a>
                    </div>
                </carousel>
            </div> -->
        </div>
        <!-- Menampilkan Produk Lainnya -->
        <action-sheet ref="product" :title="'Pilih Produk'" :inset="false" :content-full="true"> 
            <ul class="listview image-listview">
                <li v-for="item in categoryPrabayar" :key="'PRA-'+item.id">
                    <a style="cursor:pointer;" class="item" @click="selectProduct('PRABAYAR',item)">
                        <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="image">
                        <div class="in">
                            <div>{{ item.product_name }}</div>
                        </div>
                    </a>
                </li>
                <li v-for="item in categoryPascabayar" :key="'PASCA-'+item.id">
                    <a style="cursor:pointer;" class="item" @click="selectProduct('PASCABAYAR',item)">
                        <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="image">
                        <div class="in">
                            <div>{{ item.product_name }}</div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import carousel from 'vue-owl-carousel'
export default {
    name: 'Beranda',
    components: { carousel },
    data: () => ({
        loading:{
            content: true
        },
        gamefav: [
            {
                id: 97,
                product_name: 'Free Fire Termurah',
                description: null,
                image: 'FF.jpg',
                icon: ''
            },
            {
                id: 117,
                product_name: 'Mobile Legends Termurah',
                description: null,
                image: 'ML.jpg',
                icon: ''
            },
            {
                id: 71,
                product_name: 'PUBG Mobile Termurah',
                description: null,
                image: 'PUBGM.jpg',
                icon: ''
            },
            {
                id: 120,
                product_name: 'Higgs Domino Termurah',
                description: null,
                image: 'HD.jpg',
                icon: ''
            }
        ]
    }),
    computed:{
        ...mapState(['setting','customer','categoryPrabayar','categoryPascabayar','banner', 'VUE_ENV','toast']),
        chunkCategoryUtama(){
            return window._.chunk(window._.toArray(this.categoryPrabayar.slice(0, 11)),4)
        },
    },
    methods:{
        ...mapActions(['getCategoryPrabayar','getCategoryPascabayar','getCategoryPascabayar','getBanner', 'getCustomer', 'getSetting','coming']),
        showInformation(information_id){
            if(information_id != null){
                this.$router.push({name:'info.index', params:{information_id:information_id}});
            }
        },
        modalProduct(value){
            if(this.$refs.product != undefined){
                let element = this.$refs.product.$el
                window.$(element).modal(value)
            }
        },
        selectProduct(type,data){
            this.modalProduct('hide')
            if(type === 'PRABAYAR'){
                if(data.withPrefix === 1){
                    this.$router.push({name:'order-prabayar', params:{id:data.id, title:data.product_name, withPrefix:data.withPrefix}})
                }else{
                    this.$router.push({name:'product-prabayar', params:{id:data.id, title:data.product_name, withPrefix:data.withPrefix, styleProduct:data.style_product}})
                }
                
            }else{
                this.$router.push({name:'pascabayar', params:{id:data.id, title:data.product_name}})
            }
        }
    },
    mounted() {
        this.getCustomer().then(() => {
            this.loading.content = false
        }).catch(() => {
            this.loading.content = false
        })
        this.getBanner()
        if(this.categoryPrabayar[0].product_name === 'Loading...'){
            this.getCategoryPrabayar()
            this.getCategoryPascabayar()
        }

        if(Object.keys(this.setting).length == 0){
            this.getSetting()
        }
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    },
}
</script>